import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
// Components
import SignIn from './SignIn';

// Actions
import { doLogin } from 'store/reducers/login/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

export default compose(
  injectIntl,
  connect(
    null,
    { doLogin, gtmUserEvent }
  )
)(SignIn);



// WEBPACK FOOTER //
// ./src/components/pages/User/SignIn/SignInContainer.js